import { apiRequest } from "./apiClient";

export const spendDataEnrichmentService = {

  getLatestRecord: async () => {
    return apiRequest(
      "/api/spend-data-enrichment/latest"
    );
  },

  getByTraceId: async (traceId: string) => {
    return apiRequest(
      `/api/spend-data-enrichment/trace/${traceId}`
    );
  }
};
